module.exports = __webpack_public_path__ + "static/img/9.7b7281e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zddcf/9.png
// module id = a4C5
// module chunks = 0